import React, { useState } from 'react';

import { tabButton, tabs } from './Tabs.module.scss';

type Props = {
  titles: string[];
  contents: JSX.Element[];
};

export const Tabs: React.FC<Props> = ({ titles, contents }): JSX.Element => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className={tabs}>
      <div role="tablist">
        {React.Children.toArray(
          titles.map((title, index) => (
            <button
              className={tabButton}
              id={`tab-${index + 1}`}
              role="tab"
              aria-selected={index === selectedIndex ? 'true' : 'false'}
              aria-controls={`panel-${index + 1}`}
              tabIndex={index === selectedIndex ? 0 : -1}
              onClick={() => setSelectedIndex(index)}
            >
              {title}
            </button>
          )),
        )}
      </div>
      {React.Children.toArray(
        contents.map((content, index) => (
          <div
            role="tabpanel"
            tabIndex={index}
            aria-labelledby={`tab-${index + 1}`}
            hidden={index !== selectedIndex}
          >
            {content}
          </div>
        )),
      )}
    </div>
  );
};
